export const MOUSE_CAPTURING_TOOL_NAME = 'MouseCapturingTool';
